import strFunc from "@/lib/lyg/string";
import ListSimpleArea from "@/pcomponents/common/crud/list/list_simple";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

function ListArea(props: any) {
  let myProps = {
    xColumnArr: {},
    infoArr: [],
    setInfoArr: (inData: any) => { },
    select_row_num_arr: [],
    set_select_row_num_arr: (inData: any) => { },
    write_trade_by_ajax: (inData: any) => { },
    delete_trade_pay_by_ajax: (inData: any) => { },
    goWrite: (inData: any) => { },
    goDelete: (inData: any) => { },
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let infoArr = myProps.infoArr;
  let select_row_num_arr = myProps.select_row_num_arr;

  const moveOrderNum = (row_num: any, up_down: string) => {
    let tmp_section_arr: any = [...infoArr];
    let next_row_num = row_num;
    if (up_down == "up") {
      next_row_num = row_num - 1;
    } else if (up_down == "down") {
      next_row_num = row_num + 1;
    }

    if (next_row_num < 0) {
      return false;
    }
    if (next_row_num >= tmp_section_arr.length) {
      return false;
    }

    let now_row_data = tmp_section_arr[row_num];
    let change_row_data = tmp_section_arr[next_row_num];

    tmp_section_arr[row_num] = change_row_data;
    tmp_section_arr[next_row_num] = now_row_data;
    save_list_order_num_by_arr(tmp_section_arr);
    setTimeout(() => {
      myProps.setInfoArr(tmp_section_arr);
    }, 100);
  };

  const save_list_order_num_by_arr = (tmp_section_arr: []) => {
    let w_order_info_arr = [];
    for (let i = 0; i < tmp_section_arr.length; i++) {
      w_order_info_arr.push({
        "a_ymd": tmp_section_arr[i]["a_ymd"],
        "a_seq": tmp_section_arr[i]["a_seq"],
        "a_order_num": i,
      });
    }
    let write_form_data = {
      "is_update": "1",
      "data_arr": w_order_info_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/write', write_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {

        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const get_td_render_tag = (inData: any) => {
    let opt_obj: any = {
      key: "",
      value: "",
      name: "",
      row_num: 0,
      info: {},
      render_str: "",
      on_change_row_input: (inData2: any) => { },
      ...inData
    };
    let input_style: any = {
      background: "transparent",
      textAlign: "center",
    };
    if (opt_obj.key == "a_money") {
      opt_obj.render_str = (
        <input type="text" className="row-input" name={opt_obj.key} value={strFunc.comma(opt_obj.value)} title={opt_obj.value}
          autoComplete="off"
          style={input_style}
          onClick={(e: any) => {
            e.target.select();
          }}
          onChange={(e: any) => {
            let tmp_value = strFunc.uncomma(e.target.value);
            opt_obj.on_change_row_input({
              row_num: opt_obj.row_num,
              key: opt_obj.key,
              value: tmp_value,
            });
          }} />
      );
    } else if (opt_obj.key == "row_view_order") {
      opt_obj.render_str = (
        <div className="text-center">
          <button className="btn-s btn-dark" onClick={() => { moveOrderNum(opt_obj.row_num, "up"); }} >▲</button>
          <button className="btn-s btn-dark ml-1" onClick={() => { moveOrderNum(opt_obj.row_num, "down"); }} >▼</button>
        </div>
      );
    } else if (opt_obj.key == "row_view_trade") {
      opt_obj.render_str = "";
      if (opt_obj.info["trade_arr"] && opt_obj.info["trade_arr"].length > 0) {
        opt_obj.render_str = (
          <span>
            {opt_obj.info["trade_arr"].length}건
            <button className="btn-s btn-red ml-1"
              onClick={() => {
                myProps.delete_trade_pay_by_ajax({ selected_arr: [opt_obj.info] });
              }} >X</button>
          </span>
        );
      } else {
        opt_obj.render_str = (
          <span>
            {!strFunc.is_empty(opt_obj.info["a_seq"]) &&
              <button className="btn-s btn-blue"
                onClick={() => {
                  myProps.write_trade_by_ajax({ selected_arr: [opt_obj.info] });
                }} >지출등록</button>
            }
          </span>
        );
      }
    } else if (opt_obj.key == "row_view_manage") {
      opt_obj.render_str = (
        <div className="text-center">
          <button className="btn-s btn-blue" 
            onClick={() => { 
              myProps.goWrite({
                selected_arr: [opt_obj.info]
              }); 
            }} >저장</button>
          <button className="btn-s btn-red ml-1"
            onClick={() => {
              myProps.goDelete({
                select_row_num_arr: [opt_obj.row_num]
              });
            }}
          >X</button>
        </div>
      );
    }
    return opt_obj.render_str;
  };


  return (
    <div>
      <ListSimpleArea
        xColumnArr={xColumnArr}
        infoArr={infoArr}
        setInfoArr={myProps.setInfoArr}
        select_row_num_arr={select_row_num_arr}
        set_select_row_num_arr={myProps.set_select_row_num_arr}
        is_select_click_multy={false}
        is_grid={true}
        get_td_render_tag={get_td_render_tag}
        table_style={{ width: "auto", margin: "0 auto" }}
        input_style={{ textAlign: "center", width: "100%" }}
        input_select_style={{ textAlign: "center" }}
      ></ListSimpleArea>
    </div>
  );
};
export default ListArea;